











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LineGraph2        from '@/components/graph/LineGraph2.vue';

@Component({
  name: 'TestTypes',
  components: {
    LineGraph2
  }
})

export default class TestTypes extends Vue {

}

